/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AuthInterceptor } from './app/core/authentication/auth.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  {
    provide: 'BASE_URL', useFactory: getBaseUrl, deps: []
  }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));
//bootstrapApplication(AppModule, {
//  providers: [
//    {
//      provide: 'BASE_URL', useFactory: getBaseUrl, deps: []
//    },
//    provideHttpClient(withInterceptors([AuthInterceptor])),

//  ]
//}).catch(err => console.log(err));
